'use client';
import { useSettings } from '@/presentation/context/settings';
import { useCallback } from 'react';
import CurrencySelect from './CurrencySelect';

export default function CurrencySelectContainer() {
  const [{ currency }, updateSettings] = useSettings();
  const setCurrency = useCallback(
    (v: 'ETH' | 'USD') => {
      updateSettings({ currency: v });
    },
    [updateSettings]
  );

  return <CurrencySelect value={currency} onChange={setCurrency} />;
}
